"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MortageRateChangeModal = void 0;
var React = _interopRequireWildcard(require("react"));
var style = _interopRequireWildcard(require("./MortageRateChangeModal.css"));
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _uiKit = require("@cian/ui-kit");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MortageRateChangeModal = props => {
  const {
    open,
    onOpenChange,
    title,
    description
  } = props;
  return /*#__PURE__*/React.createElement(_uiKit.ModalRoot, {
    open: open,
    onOpenChange: onOpenChange
  }, /*#__PURE__*/React.createElement(_uiKit.ModalContent, {
    size: "S"
  }, /*#__PURE__*/React.createElement(_uiKit.ModalCloseButton, {
    title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    size: "XS",
    theme: "fill_light",
    icon: /*#__PURE__*/React.createElement(_icons.IconActionClose16, null)
  }), /*#__PURE__*/React.createElement(_uiKit.ModalBody, null, /*#__PURE__*/React.createElement("div", {
    className: style['layout']
  }, /*#__PURE__*/React.createElement("div", {
    className: style['img']
  }), /*#__PURE__*/React.createElement("div", {
    className: style['text']
  }, /*#__PURE__*/React.createElement(_uiKit.UIHeading2, null, title), /*#__PURE__*/React.createElement(_uiKit.UIText1, {
    whiteSpace: "pre-wrap"
  }, description)))), /*#__PURE__*/React.createElement(_uiKit.ModalFooter, null, /*#__PURE__*/React.createElement(_uiKit.ModalClose, {
    asChild: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true
  }, /*#__PURE__*/React.createElement(_uiKit.Button, {
    fullWidth: true,
    size: "L"
  }, "\u041F\u043E\u043D\u044F\u0442\u043D\u043E")), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true,
    tablet: true
  }, /*#__PURE__*/React.createElement(_uiKit.Button, {
    fullWidth: true,
    size: "M"
  }, "\u041F\u043E\u043D\u044F\u0442\u043D\u043E")))))));
};
exports.MortageRateChangeModal = MortageRateChangeModal;